app.factory('templateService', function ($http) {
    return {
        list: function(page,params) {                          
            return $http.get('/template?page='+page,{params: params});
        },
        create: function(){
            return $http.get('/template/create');
        },
        store: function(data){
            return $http.post('/template',data);
        },
        show: function (id){
            return $http.get('/template/'+id);
        },
        edit: function(id){
            return $http.get('/template/'+id+'/edit');
        },
        update: function(id,data){                        
            return $http.put('/template/'+id,data); 
        },
        delete: function(ids){
            return $http.delete('/template/'+ids);
        },
        copy: function(data){
            return $http.post('/template/copy',data);
        },
        createmsg: function(id){
            return $http.post('/template/createmsg',{id:id});
        }        
    };
});